export interface Assignee {
  id: string;
  name: string;
  type: 'user' | 'persona';
}

export type TaskStatus = 'todo' | 'in_progress' | 'done' | 'rejected';

export interface TaskRequest {
  name: string;
  description: string;
  status?: TaskStatus;
  priority?: number;
  assigned_to_id?: string | null;
  due_date?: string; // ISO date
  tags?: string[];
}

export interface Task {
  task_id: string;
  name: string;
  assigned_to: Assignee | null;
  created_by: Assignee;
  created_at: number;
  updated_at: number;
  description: string;
  due_date: string; //ISO date
  status: TaskStatus;
  priority: number;
  tags: string[];
}

export interface TaskDetails extends Task {
  history: TaskHistory[];
  comment: TaskComment[];
}

export interface CommentRequest {
  content: string;
}

export type ChangeType =
  | 'created'
  | 'status_changed'
  | 'renamed'
  | 'description_changed'
  | 'priority_changed'
  | 'comment_added'
  | 'comment_updated'
  | 'comment_deleted'
  | 'updated';

export interface TaskHistory {
  history_id: string;
  change_type: ChangeType;
  changed_by?: Assignee;
  changes: Record<string, { old: string; new: string }>;
  created_at: string; //ISO date
}
export interface TaskComment {
  comment_id: string;
  created_at: number;
  updated_at: number;
  comment: string;
  created_by: Assignee;
}
